module.exports = __webpack_public_path__ + "img/bannerN4.7b26b64d.png";